import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1165e404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "bi-tmpl-detail__right__cmpt__des" }

import _ from 'lodash';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModulePercent from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-task-percent/index';
import { data_4_3 } from '../../../../../../hooks/use-preview';

const CHILD_KEY = '4_3_2';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-4-3-2',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4, 5].map(i => {
  return {
    value: 'pc-module-task-percent-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModulePercent.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });

const onChangeFn = _.debounce(val => {
  if (curItem.value === val) {
    onChange(null);
  } else {
    onChange(val);
  }
}, 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 175,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"160px","width":"100%"},
            key: index,
            onClick: ($event: any) => (_unref(onChangeFn)(item.value))
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"160px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), {
                      style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0"},
                      tableHeaderList: _unref(data_4_3).table.header,
                      tableDataList: _unref(data_4_3).table.value
                    }, null, 8, ["tableHeaderList", "tableDataList"]))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(data_4_3).resultSystem), 1)
  ]))
}
}

})